import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region components
import { useCheckRelations } from "components/common";
import Dashboard from "./dashboard";
import { RevisorDashboard } from "components/revisor";
//#endregion

const Home: React.FC = () => {
  const { getIsRevisor } = useCheckRelations();
  const isRevisor = getIsRevisor();
  const isAuditorAssistant = useSelector((state: AppState) => state.auth.selectedCompany.loggedInUserIsAuditorAssistant);

  return (
    <>
      {isRevisor || isAuditorAssistant ? <RevisorDashboard /> : <Dashboard />}
    </>
  );
};

export default Home;
